module.exports = __webpack_public_path__ + "img/qqpthy.83000fc4.jpg";